export default __webpack_public_path__ + "static/media/518a2f9176224ce2ce9304663c6b9c91.61464919.jpg";